import {Command} from './Command';
import {Car} from '../../types/car';
import GetCarsResponse from '../responses/GetCarsResponse';

export default class GetCarsCommand extends Command {
    name = 'car';

    usesLanguage = true;

    // public handle($arguments: any): Promise<SomeCheckFormDataResponse> {
    public handle($arguments: any): Promise<Car[]> {
        console.log('GetCarsCommand->handle');

        // return this.apiResponse<SomeCheckFormDataResponse>('get', this.name, $arguments, SomeCheckFormDataResponse);
        return this.apiResponse<GetCarsResponse>('get', this.name, $arguments, GetCarsResponse)
          .then((resp: GetCarsResponse) => resp.data);
    }

    protected fake(method: string, $arguments: any): Promise<any> {
      return Promise.resolve({
        success: true,
        data: [
        ]
      });

      return Promise.reject({
          success: false,
          error: {
              code: 'nG12',
              note: 'Слишком много ошибок',
              fields: {
                  height: 'Высота паллеты не может быть менее 50 см',
                  townSender: 'Мы сюда не возим, это ж, блин, Рио-Де-Жанейро!!',
                  tarif: 'Неправильно выбран тариф',
                  weight: 'Нельзя по украинским дорогам возить груз свыше 202 тонн'
              }
          }
      });
    }
}
